import {HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideRouter, RouterFeatures, ViewTransitionsFeatureOptions, withComponentInputBinding, withDebugTracing, withEnabledBlockingInitialNavigation, withViewTransitions} from '@angular/router';
import {Shared} from '@app-store-management';
import {TokenInterceptor} from '@auth/data-access';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {environment} from '@shared-types';

import {appRoutes} from '../app.routes';
import {HttpLoaderFactory} from '../factories/translate-http-loader-factory';
import {ExternalModules} from './app-ext-modules.config';
import AppProviders from './app-providers.config';

import APP_STORE_PROVIDERS = Shared.APP_STORE_PROVIDERS;
import {DATE_PIPE_DEFAULT_OPTIONS} from '@angular/common';

export function withSafeViewTransitions(options?: ViewTransitionsFeatureOptions) {
	// only if the document is visible, return withViewTransitions with the additional options
	if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
		const mergedOptions: ViewTransitionsFeatureOptions = {
			skipInitialTransition: true,
			...options,
			onViewTransitionCreated: info => {
				try {
					options?.onViewTransitionCreated?.(info);

					if (info?.from?.url?.[0]?.path && info?.to?.url?.[0]?.path) {
						console.log(`view transition from ${info?.from?.url?.[0]?.path} to ${info?.to?.url?.[0]?.path}`);

						if (info?.from?.url?.[0]?.path === info?.to?.url?.[0]?.path) {
							info?.transition?.skipTransition();
						}
					}
				} catch (error) {
					console.error('[withSafeViewTransitions] Error during onViewTransitionCreated:', error);
				}
			},
		};
		return withViewTransitions(mergedOptions);
	}
	return null;
}

/**
 * @warn don't change the order of providers
 */
export const appConfig: () => ApplicationConfig = () => {
	const routerProviderFeatures: RouterFeatures[] = [withEnabledBlockingInitialNavigation(), withComponentInputBinding(), withSafeViewTransitions()].filter(Boolean);

	return {
		providers: [
			provideZoneChangeDetection({eventCoalescing: true}),
			...AppProviders,
			importProvidersFrom([
				TranslateModule.forRoot({
					loader: {
						provide: TranslateLoader,
						useFactory: HttpLoaderFactory,
						deps: [HttpClient],
					},
				}),
				...ExternalModules,
			]),
			...APP_STORE_PROVIDERS,
			{
				provide: DATE_PIPE_DEFAULT_OPTIONS,
				useValue: {dateFormat: 'dd/MM/yyyy', timezone: 'browser'},
			},
			provideRouter(appRoutes, ...routerProviderFeatures),
			provideHttpClient(withInterceptors([TokenInterceptor()]), withInterceptorsFromDi()),
			provideAnimations(),
		],
	};
};
